import { Box } from "@mui/material";

export default function PillBadge({ slideOrderId }) {
  return (
    <Box
      key={slideOrderId}
      sx={{
        width: "70px",
        height: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        border: "1px solid",
        borderColor: "grey.300",
        fontSize: "0.75rem",
        fontWeight: 600,
      }}
    >
      {slideOrderId}
    </Box>
  );
}
